import { Box, Typography } from "@mui/material";

import ExecutionSummary from "../TestCase/TestcaseAutomationTab/ExecutionSummary";
import ResultTab from "../TestCase/TestcaseAutomationTab/ResultTab";

const ScrollableContent = ({ executionSummary, executionSteps }) => {
  const grayBorderStyle = {
    border: "1px solid rgb(222, 226, 233)",
    borderRadius: "8px",
    padding: "1.5rem",
  };

  return (
    <Box p={2} sx={{ overflowY: "auto", flexGrow: 1 }}>
      <Box sx={{ pr: 1 }}>
        {executionSteps?.length > 0 && (
          <div
            style={{
              ...grayBorderStyle,
              padding: "1.5rem",
              marginBottom: 24,
              marginTop: 20,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 22,
                  color: "#0f172a",
                  paddingRight: 32,
                }}
              >
                Execution Results
              </Typography>
            </Box>
            <ResultTab stepResults={executionSteps} isSavedResult={true} />
          </div>
        )}

        {executionSummary && (
          <ExecutionSummary executionSummary={executionSummary} />
        )}
      </Box>
    </Box>
  );
};

export default ScrollableContent;
